import type { Reducer, AnyAction } from 'redux';

import type { TourPropsMap } from '@features/app-tour/app-tour.models';

import { SET_TOUR_PROPS } from '../action-types';

export interface TourState {
  tourProps: TourPropsMap | false;
}

export const defaultState: TourState = {
  tourProps: false,
};

const reducer: Reducer<TourState> = (
  state = defaultState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_TOUR_PROPS:
      return {
        ...state,
        tourProps: action.props,
      };

    default:
      return state;
  }
};

export default reducer;
